import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import { confirmWebpay } from "../services/api";

const statusText = {
  approved: { title: "Pago aprobado", color: "text-green-600" },
  rejected: { title: "Pago rechazado", color: "text-red-600" },
  created: { title: "Pago en proceso", color: "text-amber-600" },
  error: { title: "Error en el pago", color: "text-red-600" },
};

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const [loading, setLoading] = React.useState(true);
  const [purchase, setPurchase] = React.useState(null);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const token = params.get("token_ws");
    if (!token) {
      setError("Falta token_ws en la URL de retorno.");
      setLoading(false);
      return;
    }
    confirmWebpay(token)
      .then((resp) => {
        setPurchase(resp);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "No se pudo confirmar el pago.");
        setLoading(false);
      });
  }, [params]);

  const statusInfo = statusText[purchase?.status] || statusText.error;

  return (
    <>
      <Navbar navclass="defaultscroll is-sticky" navlight={true} manuclass="justify-end nav-light" />
      <section className="relative md:py-16 py-12">
        <div className="container">
          <div className="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800 p-6 max-w-2xl mx-auto text-center">
            <h1 className="text-2xl font-semibold mb-2">Resultado del pago</h1>
            {loading && <p className="text-slate-500">Validando con Webpay...</p>}
            {!loading && error && <p className="text-red-600 font-medium">{error}</p>}
            {!loading && !error && purchase && (
              <div className="space-y-3">
                <p className={`text-lg font-semibold ${statusInfo.color}`}>{statusInfo.title}</p>
                <p className="text-sm text-slate-600 dark:text-slate-400">
                  Orden: {purchase.buy_order} · Monto: {(purchase.amount_cents).toLocaleString("es-CL", { style: "currency", currency: purchase.currency || "CLP", minimumFractionDigits: purchase.currency === "CLP" ? 0 : 2, maximumFractionDigits: purchase.currency === "CLP" ? 0 : 2 })}
                </p>
                {purchase.authorization_code && (
                  <p className="text-sm text-slate-600 dark:text-slate-400">
                    Código de autorización: {purchase.authorization_code}
                  </p>
                )}
                {purchase.response_code !== null && purchase.response_code !== undefined && (
                  <p className="text-xs text-slate-500">Respuesta Webpay: {purchase.response_code}</p>
                )}
              </div>
            )}
            <div className="mt-6 flex justify-center gap-4">
              <Link to="/cart" className="text-red-500 font-semibold hover:underline">
                Volver al carrito
              </Link>
              <Link to="/grid" className="text-slate-700 dark:text-slate-200 font-semibold hover:underline">
                Seguir explorando
              </Link>
              {!loading && !error && purchase && (
                <Link
                  to={`/user-invoice?ref=${encodeURIComponent(purchase.buy_order)}`}
                  state={{ purchase }}
                  className="text-white bg-red-500 hover:bg-red-600 font-semibold px-3 py-2 rounded-md"
                >
                  Ver comprobante
                </Link>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Switcher />
    </>
  );
}
